import { NdPromptEditor } from "@/components/admin/NdPromptEditor";

export function SettingsPromptsPage() {
  return <NdPromptEditor />;
}
